module.exports = __webpack_public_path__ + "media/images/marisol/marisol1-0a88b8fd8a590ab26e6778815f4e230a.png";